import Check from "@mui/icons-material/Check";
import { Box, Tooltip } from "@mui/material";

/**
 * Why the portal's answer differs from the app's, per state. Only the states
 * `portalEhsColumn` renders for need an entry; a state with none shows the
 * value without a tooltip.
 */
const DIFFERENCE_REASONS: Record<string, string> = {
  CA: "CERS reports a mixture as not EHS and marks only its EHS components",
};

type Props = {
  /**
   * The facility's state, taken from the page rather than the row: a chemical
   * read back from a report snapshot carries no facility of its own.
   */
  state: string | null | undefined;
  chemical: { isEhs?: boolean | null; portalIsEhs?: boolean | null } | null | undefined;
};

/**
 * The EHS answer the state portal receives, shown beside the app's own EHS
 * column. Reads `portalIsEhs`: the server resolves it for a live row, and a
 * snapshot row carries what that report was submitted with (filled in on read
 * for a CA snapshot predating the field). A row with neither falls back to
 * `isEhs`, as Geppetto does.
 */
export function PortalEhsCell({ state, chemical }: Props) {
  if (!chemical) return null;
  const portalIsEhs = chemical.portalIsEhs ?? chemical.isEhs === true;
  const mark = portalIsEhs ? <Check /> : <>&mdash;</>;
  if (portalIsEhs === (chemical.isEhs === true)) return mark;
  // Wrapped so the tooltip has an element to anchor to, and so the dash keeps
  // the icon's alignment in the centered column.
  return (
    <Tooltip title={DIFFERENCE_REASONS[state ?? ""] ?? ""}>
      <Box sx={{ display: "inline-flex", alignItems: "center" }}>{mark}</Box>
    </Tooltip>
  );
}
